<template>
  <a-simple-tooltip @tooltip-close="$emit('tooltip-close')">
    <template #text>
      <template v-if="changed">
        {{ $translate('post.actionResults.changed') }}
      </template>
      <template v-else-if="alreadyPerformed">
        {{ $translate('post.actionResults.alreadyVotedStart') }}
        <strong class="anz-strong">{{
          $translate('post.actionResults.alreadyVotedStrong')
        }}</strong>
        {{ $translate('post.actionResults.alreadyVotedEnd') }}
      </template>
      <template v-else>
        <strong class="anz-strong">{{
          $translate('post.actionResults.votedStrong')
        }}</strong
        >{{ $translate('post.actionResults.votedEnd') }}
      </template>
    </template>
  </a-simple-tooltip>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { TOOLTIP_COMPONENTS } from '@/composables/post/postTooltip'
import ASimpleTooltip from '@/components/Ui/ASimpleTooltip.vue'

export default defineComponent({
  name: TOOLTIP_COMPONENTS.POST_VOTE,
  emits: ['tooltip-close'],
  components: { ASimpleTooltip },
  props: {
    alreadyPerformed: {
      type: Boolean,
      default: false,
    },
    changed: {
      type: Boolean,
      default: false,
    },
  },
})
</script>
